export default "__VITE_ASSET__CJPL_8WT__"